let token = null;

export default function() {
    if (!token) {
        const meta = document.querySelector('meta[name="csrf-token"]');
        token = meta && meta.content;
    }
    return token;
}
